import React from 'react';
import DescriptionList from '../../../../components/DescriptionList.js';
import DescriptionListItem from '../../../../components/DescriptionListItem.js';
import { PurchaseLot } from '../../../../../../types/entities.js';

interface Props {
  lot: PurchaseLot;
}

const LotMemberBenefits: React.FC<Props> = ({ lot }) => {
  if (!lot.memberBenefits && !lot.memberRequirements) {
    return null;
  }

  return (
    <>
      <h3>Преимущества, требования к участникам</h3>
      <DescriptionList>
        {!!lot.memberBenefits && (
          <DescriptionListItem
            title="Преимущества"
            definition={lot.memberBenefits}
          />
        )}

        {!!lot.memberRequirements && (
          <DescriptionListItem
            title="Требования к участникам"
            definition={lot.memberRequirements}
          />
        )}
      </DescriptionList>
    </>
  );
};

export default React.memo(LotMemberBenefits);
